import { Component, type ErrorInfo, type ReactNode } from "react";

interface ErrorBoundaryState {
  failed: boolean;
}

export class AppErrorBoundary extends Component<
  { children: ReactNode },
  ErrorBoundaryState
> {
  override state: ErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("UI boundary caught an error.", {
      componentStack: info.componentStack,
      name: error.name,
    });
  }

  override render(): ReactNode {
    if (this.state.failed) {
      return (
        <main className="error-view">
          <h1>Interface unavailable</h1>
          <p>Reload the application to recover.</p>
        </main>
      );
    }

    return this.props.children;
  }
}
